import manifest from '../src/manifest/manifestV3.json'

// Open (or create) a database
function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('my-database', 1)

    request.onupgradeneeded = event => {
      const db = event.target.result
      if (!db.objectStoreNames.contains('keyval')) {
        db.createObjectStore('keyval')
      }
    }

    request.onsuccess = event => {
      resolve(event.target.result)
    }

    // eslint-disable-next-line unicorn/prefer-add-event-listener
    request.onerror = event => {
      reject(event.target.error)
    }
  })
}

// Set a key-value pair
function setItem(value) {
  return openDB().then(db => {
    return new Promise((resolve, reject) => {
      const transaction = db.transaction('keyval', 'readwrite')
      const store = transaction.objectStore('keyval')
      const request = store.put(value, 'default')

      request.onsuccess = () => resolve()
      // eslint-disable-next-line unicorn/prefer-add-event-listener
      request.onerror = event => reject(event.target.error)
    })
  })
}

// Get a value by key
function getItem(key) {
  return openDB().then(db => {
    return new Promise((resolve, reject) => {
      const transaction = db.transaction('keyval', 'readonly')
      const store = transaction.objectStore('keyval')
      const request = store.get('default')

      request.onsuccess = event => {
        const value = Object.fromEntries(
          Object.entries(event.target.result || {}).filter(
            ([k]) =>
              !key || (Array.isArray(key) ? key.includes(key) : k === key)
          )
        )
        resolve(value)
      }
      // eslint-disable-next-line unicorn/prefer-add-event-listener
      request.onerror = event => reject(event.target.error)
    })
  })
}

export const storage = {
  local: {
    async set(v) {
      const current = await getItem()
      Object.assign(current, v)
      await setItem(current)
    },
    async get(k) {
      return (await getItem(k)) || {}
    },
  },
}

export const i18n = {
  getAcceptLanguages() {
    return ['en-US']
  },
}
export const action = {
  setBadgeBackgroundColor() {},
  setBadgeText() {},
}
export const tabs = {}
class Windows {
  async getCurrent() {
    return {}
  }

  onFocusChanged = {
    listeners: [],
    addListener: callback => {
      this.onFocusChanged.listeners.push(callback)
    },
  }
}

export const windows = new Windows()

class PortAdapter {
  port
  sender = { tab: { id: 1 } }

  onMessage = {
    listeners: [],
    addListener: callback => {
      this.onMessage.listeners.push(callback)
    },
  }

  onDisconnect = {
    listeners: [],
    addListener: callback => {
      this.onDisconnect.listeners.push(callback)
    },
  }

  constructor(port, _sender) {
    this.sender = _sender || this.sender
    this.port = port

    // Listen for messages and notify listeners
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    this.port.onmessage = event => {
      for (const listener of this.onMessage.listeners) {
        listener(event.data, this)
      }
    }

    // Listen for the port closing and notify disconnect listeners
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    this.port.onmessageerror = () => {
      for (const listener of this.onDisconnect.listeners) {
        listener()
      }
    }
  }

  postMessage(message) {
    this.port.postMessage(message)
  }

  disconnect() {
    this.port.close()
    for (const listener of this.onDisconnect.listeners) {
      listener(this)
    }
  }
}

class Runtime {
  onConnect = {
    listeners: [],
    addListener: callback => {
      this.onConnect.listeners.push(callback)
    },
  }

  onInstalled = {
    listeners: [],
    addListener: callback => {
      this.onInstalled.listeners.push(callback)
    },
  }

  connectRequests = []
  serviceConnected = false
  serviceListening = false
  openChannels = {}

  getPlatformInfo() {
    return { os: 'mac', arch: 'arm64' }
  }
  getManifest() {
    return manifest
  }
  requestPorts() {
    while (true) {
      const request = this.connectRequests.shift()
      if (!request) break
      this.serviceListening.postMessage(
        { name: request.name, sender: 'popup' },
        [request.channel.port2]
      )
    }
  }

  connect({ name }) {
    const channel = new MessageChannel()
    this.connectRequests.push({ name, channel })
    this.openChannels[name] = channel
    const adapter = new PortAdapter(channel.port1)
    adapter.onDisconnect.addListener(() => {
      delete this.openChannels[name]
    })

    if (this.serviceListening) {
      this.requestPorts()
    } else if ('serviceWorker' in navigator && !this.serviceConnected) {
      this.serviceConnected = true
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/background.js', { scope: '/' })
          .then(registry => {
            console.log('Service worker registered', registry)
            this.serviceListening = registry.active
            this.requestPorts()
          })
      })
    }
    return adapter
  }
}
class Scripting {
  registerContentScripts() {}
}
export const scripting = new Scripting()
export const runtime = new Runtime()

self.addEventListener('message', event => {
  if (event.data.sender === 'popup') {
    for (const listener of runtime.onConnect.listeners) {
      listener(new PortAdapter(event.ports[0], { id: 'background' }))
    }
  }
})
const browser = { storage, i18n, tabs, windows, runtime, scripting, action }
export default browser
